<template>
  <div class="form-group">
    <div v-if="auxParam==='date' || auxParam==='datetime'">
      <b-form-input id="dt"
                    class="form-control input-lg"
                    type="date"
                    v-model="date">
      </b-form-input>
    </div>

    <div v-if="auxParam==='time' || auxParam==='datetime'">
      <b-form-input id="tm"
                    class="form-control input-lg"
                    type="time"
                    v-model="time">
      </b-form-input>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      question: {
        required: true,
        type: Object,
      },
      auxParam: {
        required: true,
        type: String,
      },
    },
    data () {
      return {
        date: '2018-01-01',
        time: '00:00',
      }
    },
    methods: {
      recalc () {
        if (this.auxParam === 'date') {
          this.question.GivenAnswer = this.date
        } else if (this.auxParam === 'time') {
          this.question.GivenAnswer = this.time
        } else if (this.auxParam === 'datetime') {
          this.question.GivenAnswer = this.date + ' ' + this.time
        }
      }
    },
    watch: {
      date: function (n, o) { this.recalc() },
      time: function (n, o) { this.recalc() }
    },
    created () {
      if (this.question.GivenAnswer) {
        if (this.auxParam==='time') {
          this.time = this.question.GivenAnswer
        } else if (this.auxParam==='date') {
          this.date = this.question.GivenAnswer
        } else {
          let datetime = this.question.GivenAnswer.split(" ")
          this.date = datetime[0]
          this.time = datetime[1]
        }
      }
    },
    beforeDestroy () {
      this.recalc()
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/surveys/types/Datetime.vue